import { ReactComponent as Analytics } from './analytics.svg'
import { ReactComponent as Bookings } from './bookings.svg'
import { ReactComponent as Marketing } from './marketing.svg'
import { ReactComponent as Messaging } from './messaging.svg'
import { ReactComponent as PCI } from './pci.svg'

const PermissionIcon = ({ name }) => {
  switch (name) {
    case 'messaging':
      return <Messaging />
    case 'dashboard':
      return <Analytics />
    case 'bookings':
      return <Bookings />
    case 'marketing':
      return <Marketing />
    case 'pci':
      return <PCI />

    default:
      return null
  }
}

export default PermissionIcon
